import { controls } from "../controls";

const tr307 = {
  label: "Scroll",
  starting: true,
  url: "tr307",
  pageLabel: "Dividand Transfer To Accounts(Single)",
  pageType: "history",
  filter: [
    ...controls.displayText({ label: "Region", width: "col-sm-2" }),
    ...controls.Region(),
    {
      inputType: "showdata",
      tab: "Modal",
      data: "region",
      textcolor: "black",
      name: "region_display",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },

    ...controls.displayText({ label: "Branch", width: "col-sm-2" }),
    ...controls.branch({ defaultValue: "assigned_branch", isReadOnly: true, isRequired: true, star: true }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-4" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", label: "Member Type", width: "col-sm-2" }),
    {
      inputType: "select",
      default: "",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "Regular",
          value: "Regular"
        },
        {
          label: "Associated",
          value: "Associated"
        },
        {
          label: "Nominal(B Class)",
          value: "Nominal(B Class)"
        },

      ],
      placeHolder: "Member Type",
      name: "MemberType",
      description: "Enter Member Type"
    },

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),


    ...controls.displayText({ tab: "filter", label: "Member Number From-To", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "member_number_from", width: "col-sm-1" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-0" }),
    ...controls.numberOnly({ tab: "filter", name: "member_number_to", width: "col-sm-1" }),


    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),

    ...controls.magicDateLabel({ tab: "filter", label: "Up To Date", width: "col-sm-2" }),
    ...controls.magicDate({ isReadOnly: true, name: "up_to_date", default: "sessiondate", width: "col-sm-2", dateType: "ontype", }),

    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),


    ...controls.magicDateLabel({ tab: "filter", label: "Post Date", width: "col-sm-2" }),
    ...controls.magicDate({ isReadOnly: true, name: "up_to_date", default: "sessiondate", width: "col-sm-2", dateType: "ontype", }),

    ...controls.radio({ width: "col-sm-3", name: "cdflag", cwidth: "col-sm-4", options: [{ label: "Trial", value: "trial" }, { label: "Post", value: "post" }], clearChildren: [{}] }),
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),


    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },

    ...controls.displayText({ label: "Dividend Paid", tab: "filter", width: "col-sm-2" }),

    ...controls.GL(),
    {
      inputType: "showdata",
      tab: "Modal",
      data: "gl",
      textcolor: "black",
      name: "gl_code_display",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },


    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Dividand Transfer To Accounts(Single)",
    clickable: false,
    extraRows: {
      fields: ["credit_cash", "debit_cash"],
      grandtotal: { type: "fixed", displayIn: "description", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },
    displayColumns: [
      {
        Header: "Srno",
        accessor: "srno",
        width: 150
      },
      {
        Header: "Member To",
        accessor: "member_no",
        width: 150
      },
      {
        Header: "CIN",
        accessor: "cin",
        width: 150
      },
      {
        Header: "Name",
        accessor: "full_name",
        width: 150
      },

      {
        Header: "Balance",
        accessor: "balance",
        width: 150
      },

      {
        Header: "Trf To Acctcode",
        accessor: "ac_no",
        width: 150
      },

    ]
  }
};

export default tr307;